import { Component, inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet } from '@angular/material/bottom-sheet';
import { CsIconModule } from '@components/icon';
import { EventLoggerService } from '@services/event-logger-service';

@Component({
  selector: 'regimen-reorder-price-details-bottomsheet',
  imports: [CsIconModule],
  templateUrl: './regimen-reorder-price-details-bottomsheet.component.html',
})
export class RegimenReorderPriceDetailsBottomsheetComponent implements OnInit {

  data = inject(MAT_BOTTOM_SHEET_DATA);
  bottomSheet = inject(MatBottomSheet);
  productsTotalMrp: number;
  cashUsed: number;
  originalDiscount: number;
  private readonly eventLoggerService = inject<EventLoggerService>(EventLoggerService);

  ngOnInit(): void {
    this.eventLoggerService.cleverTapEvent('impression', JSON.stringify({
      name: 'regimen_reorder_price_details_sheet',
      totalMrp: this.data.regimenDetails.totalMrp,
      totalSP: this.data.regimenDetails.totalSP,
      discountInRupees: this.data.regimenDetails.discountInRupees,
      regimenClass: this.data.regimenDetails.regimenClass
    }));
    this.productsTotalMrp = this.data.regimenDetails.products.reduce((acc: number, product: any) => acc + product.mrp, 0);
    this.cashUsed = this.data.cashUsed || 0;
    this.originalDiscount = this.data.originalDiscount || 0;
  }

  closeBottomSheet(): void {
    this.bottomSheet.dismiss();
  }

}
